import React from "react";
import SecretInput from "./SecretInput";
import { TestResults } from "./HttpResourceForm";

/**
 * The connection form — Mongo DB, MySQL, and any other data-source type.
 *
 * Every type shares this layout and differs only in its field list and default
 * port, which come from DB_SCHEMAS in resourceTypes.js. A type with one way to
 * connect has no `connectionMethods` and the radio row is left out rather than
 * shown with a single option in it.
 */
// readOnly: the View mode — every field locked through <fieldset disabled>.
export default function DbResourceForm({
  schema,
  connection,
  onChange,
  test,
  errors = {},
  isEdit,
  nameStatus = {},
  readOnly = false,
}) {
  const set = (patch) => onChange({ ...connection, ...patch });

  return (
    <div className="rsce-db">
      {/* <h2 className="rsce-db-title">{isEdit ? "Edit Resource" : "New Resource"}</h2> */}
      <h2 className="rsce-db-title">{readOnly ? "View Resource" : isEdit ? "Edit Resource" : "New Resource"}</h2>

      <fieldset className="rsce-fieldset" disabled={readOnly}>

      {schema.connectionMethods && (
        <div className="rsce-db-methods">
          <div className="rsce-field-label">Connection Method</div>
          <div className="rsce-db-method-radios">
            {schema.connectionMethods.map((method) => (
              <label className="rsce-radio" key={method.value}>
                <input
                  type="radio"
                  name="rsce-conn-method"
                  checked={connection.connectionType === method.value}
                  onChange={() => set({ connectionType: method.value })}
                />
                <span className="rsce-radio-label">{method.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="rsce-db-grid">
        {schema.fields.map((field) => (
          <div className="rsce-field" key={field.key}>
            <label className="rsce-field-label">
              {field.label}
              {field.required && <span className="rsce-req">*</span>}
            </label>
            {field.secret ? (
              <SecretInput
                value={connection[field.key]}
                onChange={(value) => set({ [field.key]: value })}
                placeholder={field.placeholder}
              />
            ) : (
              /* The Name box spins while the server is being asked whether that
                 name is free — inside the box, where the typing happened. */
              <span className="rsce-input-wrap">
                <input
                  className={`rsce-input ${errors[field.key] ? "has-error" : ""}`}
                  type="text"
                  placeholder={field.placeholder}
                  value={connection[field.key] || ""}
                  onChange={(e) => set({ [field.key]: e.target.value })}
                />
                {field.key === "name" && nameStatus.checking && (
                  <span className="rsce-inline-spinner" aria-label="Checking name" />
                )}
                {field.key === "name" && !nameStatus.checking && nameStatus.available && !errors.name && (
                  <span className="rsce-inline-tick" title="That name is free" aria-label="Name is available" />
                )}
              </span>
            )}
            {errors[field.key] && <span className="rsce-error-text">{errors[field.key]}</span>}
          </div>
        ))}
      </div>
      </fieldset>

      <TestResults test={test} />
    </div>
  );
}
